import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: `${config.API_BASE_URL}/api/usuarios-home`,
});

export const getUsuarios = async (token) => {
  const response = await api.get('/', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const getUsuarioById = async (id, token) => {
  const response = await api.get(`/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const createUsuario = async (usuarioData, token) => {
  const response = await api.post('/', usuarioData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const updateUsuario = async (id, usuarioData, token) => {
  const response = await api.put(`/${id}`, usuarioData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const deleteUsuario = async (id, token) => {
  const response = await api.delete(`/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
